/* Which marque the selector row is showing, and keeping it said.

   EVERY PIECE OF SHIFTR STYLING KEYS OFF ONE ATTRIBUTE. data-fx-brand on
   .vin-fx-brand-switch is what turns the card black, squares its corners,
   swaps the wordmark and puts the values in white. The extension writes that
   attribute only when Show parts is pressed.

   fx-ext-vinchip.js sets it the moment a marque is picked from the menu, so the
   card answers the click instead of waiting. MEASURED: that alone is not
   enough. The extension re-renders the switch about a second later and the
   attribute goes back to futura, so the card turned black, held for a beat and
   went white again while the chips underneath still said SHIFTR 1883 and 2026.
   A one-shot set cannot survive a re-render.

   SO IT IS DERIVED, NOT REMEMBERED. The model value is the extension's own
   statement of what you are looking at, it changes on the pick, and it survives
   every re-render because the re-render is what writes it. Reading the brand
   back out of it means there is no state here to get out of step: press Back to
   My VIN and the model says Super Sport again and the card goes white on its
   own, with nothing to reset.

   THE OBSERVER HAS TO WATCH ATTRIBUTES, AND THAT IS THE WHOLE BUG THIS FILE
   EXISTED FOR A DAY WITHOUT FIXING. Watching childList and characterData
   catches the model value changing, which is what puts the card into SHIFTR.
   But the extension's reset is an ATTRIBUTE write, and an observer that is not
   watching attributes never hears it: the card reverted and nothing woke up to
   put it back. attributeFilter keeps that narrow, and pass() only writes when
   the value differs, so this cannot chase its own tail.

   THE ASSUMPTION, WRITTEN DOWN. SHIFTR model names carry the marque in them,
   as SHIFTR 1883 does. If a SHIFTR model is ever named without it, this reads
   that row as Futura and the card stays white. The fix then is a real brand
   field in the extension's markup, not a longer regular expression here.

   The brand menu's own is-selected is NOT the signal: measured, it stays on
   Futura until Show parts, which is the very wait this file exists to remove.

   setTimeout, not requestAnimationFrame: rAF does not fire in a tab that is not
   being painted, and a queued flag that is never cleared drops every mutation
   after it. */
(function () {
  var queued = null;

  function brandOf(card) {
    var src = card.querySelector('[data-chip-wrap="model"] .vin-fx-selchip-val') ||
      card.querySelector('.vin-fx-mobile-filter-label');
    if (!src) return '';
    var text = src.textContent || '';
    if (!text.trim()) return '';
    return /shiftr/i.test(text) ? 'shiftr' : 'futura';
  }

  function pass() {
    queued = null;
    var rows = document.querySelectorAll('.vin-modal .vin-fx-context-row');

    for (var i = 0; i < rows.length; i++) {
      var sw = rows[i].querySelector('.vin-fx-brand-switch');
      if (!sw) continue;
      var next = brandOf(rows[i]);
      if (!next) continue;
      if (sw.getAttribute('data-fx-brand') !== next) sw.setAttribute('data-fx-brand', next);
    }
  }

  function schedule() {
    if (queued) return;
    queued = window.setTimeout(pass, 60);
  }

  function boot() {
    pass();
    if (!window.MutationObserver) return;

    // childList and characterData: the model value changing is what puts the
    // row into SHIFTR, and it changes as a text node, not as a new element.
    // attributes: the extension's reset is a write to the very attribute this
    // file owns, and without this line nothing hears it.
    new window.MutationObserver(schedule).observe(document.body, {
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-fx-brand'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
